module.exports = __webpack_public_path__ + "img/19f7071.png";